//regex
export const twoDecimalRegex = /^(?:\d+|\d*\.\d{0,2})?$/;
export const ageRegex = /^(?:300|[0-2]?[0-9]{0,2})$/;

//regex type text
export const nameRegex = /[^A-Za-z\s]/g;
export const stringNumberRegex = /[^a-zA-Z0-9 ]/g;
export const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const icPassportRegex = /[^a-zA-Z0-9]/g;
